export default __webpack_public_path__ + "static/media/sendMsg.79c36e03.svg";